import {StyleSheet, PixelRatio} from 'react-native';
import {getScreenSize, scale} from "../../../../../../common/utils";

export default StyleSheet.create({
    searchFlightType:{
        height: scale(60),
        backgroundColor: 'rgba(255,255,255, 0.6)',
        alignItems:'flex-start',
        justifyContent:'flex-start'
    },
    searchFlightTypeItem:{
        width: 180,
        height: scale(44)
    },

    searchFlightTypeTab:{
        position: 'absolute',
        flexDirection: 'row',
        top: 0,
        left: 0
    },
    searchFlightTypeImage:{
        width: getScreenSize().width/2 + 96,
        height: scale(60),
    },
    searchMiddle:{
        width: 160,
        height: scale(61),
        backgroundColor:'#ffffff'
    },
    searchLeft:{
        height: scale(61),
        width: 60
    },
    searchRight: {
        height: scale(61),
        width: 60
    },
    searchFlightTypeContainer:{
        height: scale(44),
        width: '100%',
        flexDirection: 'row',
        alignItems:'center',
        justifyContent:'center'
    },
    activeFlightType:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(16),
        color: "#00CAD8",
        zIndex: 10
    },
    searchFlightTypeText:{
        flex: 1,
        fontSize: scale(16),
        color: "#333333",
        textAlign: "center",
    }
});